module.exports = __webpack_public_path__ + "assets/img/组 535@2x.ec7a4b67.png";